import Cookies from 'js-cookie';

import { SESSION_COOKIE_EXPIRY_DURATION_IN_DAYS } from '@src/constants/cross-domain-auth';
import { getCookieSettings } from '@src/features/auth/utils/cookies';

export class CrossDomainSessionService {
  getItem(key: string) {
    return Cookies.get(key);
  }

  setItem(key: string, value: string) {
    if (typeof window !== undefined) {
      // On dev and production environments, use cookie settings to set the cookie on .numastays.com
      Cookies.set(key, value, {
        ...getCookieSettings(window.origin),
        expires: SESSION_COOKIE_EXPIRY_DURATION_IN_DAYS,
      });
      return;
    }
    Cookies.set(key, value);
  }
}
